export const SUPPORTED_UI_LANGUAGES = new Set([
  "en",
  "pl",
  "ar",
  "az",
  "bg",
  "bn",
  "ca",
  "ceb",
  "cs",
  "da",
  "de",
  "el",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "ky",
  "lt",
  "lv",
  "ms",
  "nb",
  "nl",
  "pb",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sq",
  "sv",
  "th",
  "tl",
  "tr",
  "uk",
  "ur",
  "vi",
  "zh",
  "zt",
]);

export const normalizeSupportedLanguage = (lng, fallback = "fr") => {
  const normalized = String(lng || "").split("-")[0].toLowerCase();
  return SUPPORTED_UI_LANGUAGES.has(normalized) ? normalized : fallback;
};

